function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "m398.964 333.544-148.242-333.544-148.242 333.544 148.242-55.591zm-148.242-259.677 91.759 206.456-91.759-34.409-91.758 34.409z"
}), React.createElement("path", {
  d: "m250.722 351.934c-41.355 0-75 33.645-75 75 3.77 99.361 146.245 99.334 150-.001 0-41.355-33.645-74.999-75-74.999zm0 120c-24.813 0-45-20.186-45-45 2.262-59.617 87.747-59.6 90 .001 0 24.812-20.187 44.999-45 44.999z"
}));

var SvgMoveUp = function SvgMoveUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 501.444 501.444",
    height: 512,
    viewBox: "0 0 501.444 501.444",
    width: 512,
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMoveUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/move-up.17cc48af.svg";
export { ForwardRef as ReactComponent };